import { useState } from "react";

import { useAuth, useCurrentUser } from "../../../hooks";
import { getTimeLeftInFreeTrial } from "../../account/utils";
import UpgradeModal from "../../common/premium/UpgradeModal";

function AccountStatus({ small }) {
  const { isUserAuthenticated } = useAuth();
  const { data: userData } = useCurrentUser();
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);

  // NON PAID USERS
  if (!isUserAuthenticated) {
    return null;
  }

  const accountType = userData?.user?.account?.accountType;
  if (!accountType || accountType === "unlimited") {
    return null;
  }
  const freeTrialExpiresAt =
    userData?.user?.account?.freeTrialExpiresAt;
  const timeLeft = getTimeLeftInFreeTrial(freeTrialExpiresAt);

  const statusText =
    accountType === "basic" && !timeLeft.isExpired
      ? timeLeft.formattedTime
      : "Free Plan";

  const isTrial = accountType === "basic" && !timeLeft.isExpired;
  const featureName = isTrial ? "Trial" : "Free Plan";

  return (
    <>
      <UpgradeModal
        shouldShow={showUpgradeModal}
        setShouldShow={setShowUpgradeModal}
        featureName={featureName}
      />
      <div
        className="flex flex-row items-center space-x-2 cursor-help"
        onClick={() => setShowUpgradeModal(true)}
      >
        <div
          id="accountStatus"
          data-testid={isTrial ? "trial-status" : "free-status"}
          className={`flex items-center justify-center ${
            small ? "py-1 px-2" : "py-2.5 px-3"
          } rounded-full ${timeLeft.statusColor}`}
        >
          <span className="text-sm font-medium text-nowrap">
            {statusText}
          </span>
        </div>
      </div>
    </>
  );
}
export default AccountStatus;
